import { a as __rest } from '../../../../tslib.es6.esm.js';
import { jsx } from 'react/jsx-runtime';
import { forwardRef, useMemo, memo } from 'react';
import { useCardContext } from '../../Card.context.esm.js';
import contentStyles from './CardContent.styles.esm.js';
import { cn } from '../../../../utils/cn.esm.js';

const CardContentBase = forwardRef((_a, ref) => {
    var { className, children } = _a, rest = __rest(_a, ["className", "children"]);
    const { imagePosition } = useCardContext();
    const classes = useMemo(() => contentStyles({ imagePosition }), [imagePosition]);
    return (jsx("div", Object.assign({ ref: ref, className: cn(classes.content(), className) }, rest, { children: children })));
});
CardContentBase.displayName = "CardContent";
const CardContent = Object.assign(memo(CardContentBase), {
    __CARD_CONTENT: true,
    displayName: "CardContent",
});

export { CardContent };
